export default __webpack_public_path__ + "static/media/Dinner.9f8a18de.jpeg";